import { object, string } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  rxVendorId: string().required(),
})

export const url = ({ rxVendorId }) => `/v1/providers/${rxVendorId}/transmission-errors`
